import useIsMobile from '@/hooks/useIsMobile'
import { HeadingLabel, MetaDataLabel } from '@/styles/fonts'
import { GrandstandIcon } from '@grandstand-web/bally-web-shared/src/components/GrandstandIcon'
import { breakpoints } from '@grandstand-web/bally-web-shared/src/styles/breakpoints'
import { ActiveSubscriptionsResponse } from '@grandstand/presentation-models'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'

type SubscriptionProps = {
  onBack: () => void
  isDTCEntitled: boolean
  subscriptions: ActiveSubscriptionsResponse
  hasPurchases: boolean
  availableCredits: number
}

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
`

const Header = styled(HeadingLabel)`
  border-bottom: 1px solid var(--divider-canvas);
  padding-bottom: 25px;
  padding-left: 25px;
  padding-top: 25px;
  div {
    float: left;
    top: 3px;
    right: 10px;
    position: relative;
    @media (min-width: 768px) {
      display: none;
    }
  }
`

const FieldDiv = styled(Link)`
  display: grid;
  grid-template-columns: 100px 1fr 24px;
  grid-template-rows: 24px;
  align-items: center;
  padding: 25px;
  gap: 25px;
  width: 100%;
  border-bottom: 1px solid var(--divider-canvas);
  color: var(--on-background);
  &,
  * {
    cursor: pointer;
  }
`

const FieldLabel = styled(MetaDataLabel)`
  white-space: nowrap;
  overflow: hidden;
`

const FieldDetails = styled(FieldLabel)`
  padding-right: 0;
  text-align: right;
  text-overflow: ellipsis;
  color: var(--on-background-alt);
  ${breakpoints.down('tablet')} {
    opacity: 0;
  }
`
const FieldIcon = styled(GrandstandIcon)``

const ArrowIcon = styled(GrandstandIcon)``

const Purchases = ({ onBack, isDTCEntitled, subscriptions, hasPurchases, availableCredits }: SubscriptionProps) => {
  const router = useRouter()
  const isMobile = useIsMobile()

  const hasSubscriptions = isDTCEntitled && subscriptions.length > 0

  // get details of all subscriptions as comma-separated lists (unique values only)
  const packageDetails: string = !hasSubscriptions
    ? ''
    : Array.from(new Set(subscriptions.map((e) => e.service_name))).join(', ')
  const billingDetails: string = !hasSubscriptions
    ? ''
    : Array.from(new Set(subscriptions.map((e) => e.payment_method))).join(', ')

  const handleBackClick = () => {
    if (isMobile) {
      router.push('/settings')
      onBack()
    }
  }

  return (
    <>
      <MainContent>
        <Header onClick={handleBackClick} fontSize="4">
          <ArrowIcon icon="arrow_left" /> Purchases
        </Header>
        <FieldDiv href="/settings/packages">
          <FieldLabel fontSize="sm">Packages</FieldLabel>
          <FieldDetails fontSize="sm">{packageDetails}</FieldDetails>
          <FieldIcon icon="chevron_right" />
        </FieldDiv>
        <FieldDiv href="/settings/single-games">
          <FieldLabel fontSize="sm">Single Games</FieldLabel>
          <FieldDetails fontSize="sm">{`${availableCredits} Available`}</FieldDetails>
          <FieldIcon icon="chevron_right" />
        </FieldDiv>
        {hasSubscriptions ? (
          <FieldDiv href="/settings/billing">
            <FieldLabel fontSize="sm">Billing Details</FieldLabel>
            {/* <FieldDetails fontSize="sm">{billingDetails}</FieldDetails> */}
            <FieldDetails fontSize="sm">{billingDetails}</FieldDetails>
            <FieldIcon icon="chevron_right" />
          </FieldDiv>
        ) : null}
      </MainContent>
    </>
  )
}
export default Purchases
